import img1 from "../../images/missions/traiter/1.jpg";
import img2 from "../../images/missions/traiter/2.jpg";

import img3 from "../../images/missions/traiter/3.jpg";
import img4 from "../../images/missions/traiter/4.jpg";

import img5 from "../../images/missions/traiter/5.jpg";
import img6 from "../../images/missions/traiter/6.jpg";
import img7 from "../../images/missions/traiter/7.jpg";

import { Card, CardContent } from "../ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import MissionCards from "./MissionCards";

const MissionQuality = () => {
  const images = [
    { id: 1, img: img1 },
    { id: 2, img: img2 },
    { id: 3, img: img3 },
    { id: 4, img: img4 },
    { id: 5, img: img5 },
    { id: 6, img: img6 },
    { id: 7, img: img7 },
  ];

  return (
    <div>
      <div className="container px-4 mx-auto mt-10 mb-10 sm:px-6 lg:px-8">
        <h1 className="text-xl font-bold text-center text-black">
          Chaque jour, l’eau qui sort des robinets est utilisée à des fins
          domestiques et industrielles. Une fois « usée », elle est collectée et
          acheminée vers une usine de traitement des eaux afin d’y être
          dépolluée.
        </h1>
        <div className="py-6 mt-10 bg-white sm:py-8">
          <div className="max-w-2xl px-4 mx-auto ">
            <Carousel opts={{ align: "start", loop: true }} className="w-full">
              <CarouselContent>
                {images.map((item) => (
                  <CarouselItem key={item.img}>
                    <div className="flex items-center justify-center w-full bg-gray-200 rounded-lg h-[500px]">
                      <img
                        src={item.img}
                        alt=""
                        className="w-full h-full rounded-lg "
                      />
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="absolute flex items-center justify-center text-white transform -translate-y-1/2 bg-teal-500 border-none rounded-full left-4 top-1/2 hover:bg-teal-600" />
              <CarouselNext className="absolute flex items-center justify-center text-white transform -translate-y-1/2 bg-teal-500 border-none rounded-full right-4 top-1/2 hover:bg-teal-600" />
            </Carousel>
          </div>
        </div>
        <div className="py-6 mt-10 bg-white sm:py-8">
          <div className="flex flex-col justify-between gap-6 md:flex-row">
            <div className="w-full md:w-1/2">
              <Card>
                <CardContent className="p-4 sm:p-6">
                  <p className="mt-2 text-base font-bold">
                    <b>Le voyage des eaux usées et pluviales</b>
                  </p>
                  <p className="mt-2 text-base">
                    Chaque année, les eaux usées et pluviales de{" "}
                    <span className="text-primary">20 communes</span> s’engagent
                    dans un véritable périple à travers un vaste réseau de
                    collecteurs jusqu’à l’usine Carré de Réunion.
                  </p>
                </CardContent>
              </Card>
            </div>
            <div className="w-full md:w-1/2">
              <Card>
                <CardContent className="p-4 sm:p-6">
                  <p className="mt-2 text-base font-bold">
                    <b>Chiffre impressionnant :</b>
                  </p>
                  <p className="mt-2 text-base">
                    Plus de{" "}
                    <span className="text-primary">
                      14 millions de m³ d’eau
                    </span>{" "}
                    circulent ainsi chaque année dans ce réseau intelligent
                    conçu par{" "}
                    <span className="font-bold text-primary">Hydreaulys</span>,
                    garantissant un traitement efficace et respectueux de
                    l’environnement.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>

          <div className="mt-6 bg-white">
            <div className="overflow-hidden bg-white border border-gray-200 rounded-lg shadow-sm">
              <div className="px-4 py-3 sm:px-6 sm:py-4">
                <h2 className="text-xl font-semibold text-black">
                  Destination : deux usines stratégiques
                </h2>
              </div>
              <div className="flex mb-5">
                <div className="mr-2 bg-primary" />
                <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
                  <div className="p-4 sm:p-2 border-t md:border-t-0 md:border-l border-gray-200 border-primary min-h-[120px]">
                    <h2 className="mb-2 text-base font-semibold text-black">
                      Carré de Réunion
                    </h2>
                    <p className="text-base text-black">
                      entre Saint-Cyr-l'École et Bailly
                    </p>
                  </div>
                  <div className="p-4 sm:p-2 border-t md:border-t-0 md:border-l border-gray-200 border-primary min-h-[120px]">
                    <h2 className="mb-1 text-base font-semibold text-black">
                      Val de Gally
                    </h2>
                    <p className="mb-1 text-base text-black">A Villepreux</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20">
          <p className="text-base font-bold text-center">
            À l’usine de Carré de Réunion, les eaux collectées passent par
            différentes étapes de traitement :
          </p>
        </div>
        <div className="mt-20">
          <MissionCards />
        </div>
      </div>
    </div>
  );
};

export default MissionQuality;
